import axiosClient from './axios.client';

/**
 * Get usage statistics for all providers
 */
export const getUsageStats = async () => {
  try {
    const response = await axiosClient.get('/llm-usage');
    return { data: response.data, error: null };
  } catch (error) {
    console.error('Error fetching usage stats:', error);
    return { data: null, error: error.response?.data?.error || error.message };
  }
};

/**
 * Get usage for a specific provider
 */
export const getProviderUsage = async (provider, period = 'daily') => {
  try {
    const response = await axiosClient.get(`/llm-usage/${provider}?period=${period}`);
    return { data: response.data, error: null };
  } catch (error) {
    console.error('Error fetching provider usage:', error);
    return { data: null, error: error.response?.data?.error || error.message };
  }
};

/**
 * Get limit information for a provider
 */
export const getProviderLimits = async (provider) => {
  try {
    const response = await axiosClient.get(`/llm-usage/limits/${provider}`);
    return { data: response.data, error: null };
  } catch (error) {
    console.error('Error fetching provider limits:', error);
    return { data: null, error: error.response?.data?.error || error.message };
  }
};
